{
  "medact": [
    {
      "statusCode": 400,
      "errorCode": "INVALID_VALUE",
      "fieldId": "candidate_primary_department_org",
      "errorMessage": "The Primary Hiring Department field cannot be empty for the action to be saved."
    }
  ],
  "medonboard": [
    {
      "statusCode": 403,
      "errorCode": "ACCESS_DENIED",
      "fieldId": "candidate_primary_division_org",
      "errorMessage": "Primary Hiring Division is required based on User Access level"
    }
  ],
  "medleave": [
    {
      "statusCode": 400,
      "errorCode": "INVALID_VALUE",
      "fieldId": "leave_onduty_fte_object",
      "errorMessage": "Invalid leave values: '{{message}}'"
    },
    {
      "statusCode": 400,
      "errorCode": "INVALID_VALUE",
      "fieldId": "leave_faculty_name_options",
      "errorMessage": "Unable to find faculty: '{{message}}'"
    },
    {
      "statusCode": 400,
      "errorCode": "INVALID_VALUE",
      "fieldId": "faculty_appointment_object",
      "errorMessage": "Unable to retrieve appointment data:'{{message}}'"
    },
    {
      "statusCode": 400,
      "errorCode": "INVALID_VALUE",
      "fieldId": "accrual_beginning_balance_object",
      "errorMessage": "Invalid accrual values: '{{message}}'"
    }
  ]
}
